<template>
	<div class="input-panel">
		<div class="input-item">
			<div>当前账号</div>
			<el-input
				:modelValue="tenantContext.userName"
				style="width: 300px"
				readonly
			>
			</el-input>
		</div>

		<div class="input-item">
			<div>授权有效期</div>
			<div v-if="currentAuthCode.id">{{ scopedTime }}</div>
			<el-radio-group v-else v-model="durationOption">
				<el-radio :label="1">12小时</el-radio>
				<el-radio :label="2">1天</el-radio>
				<el-radio :label="3">7天</el-radio>
			</el-radio-group>
		</div>

		<div v-if="currentAuthCode.id" class="input-item">
			<div>授权码</div>
			<div style="color: #ca6035">
				{{ currentAuthCode.authCode }}&nbsp;
				<el-icon style="color: #3d8eff; cursor: pointer;" @click="onCopyAuthCode">
					<CopyDocument />
				</el-icon>
			</div>
		</div>

		<div class="reset-form-button">
			<el-popconfirm
				v-if="currentAuthCode.id"
				title="确定终止授权么? 终止后客服账号将自动退出"
				confirm-button-text="确定"
				cancel-button-text="暂时不"
				icon-color="red"
				:width="350"
				@confirm="onClickTerminate"
			>
				<template #reference>
					<el-button type="primary">终止授权</el-button>
				</template>
			</el-popconfirm>
			
			<el-button v-else type="primary" @click="onClickCreate()">生成授权码</el-button>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { CopyDocument } from '@element-plus/icons-vue'
import {
  catchError,
} from '@/utils'
import {
  getCurrentAuthCode,
  createAuthCode,
  terminateAuthCode,
} from 'api/access-token'
import dayjs from 'dayjs'

import * as easy from "@/components/easy";
import {ElMessage} from "element-plus";

const router = useRouter()
// 从url取product参数
const product = router.currentRoute.value.query['_channel'] as string || '';

const tenantContext = easy.getTenantContext();

// 授权时长选项:1(12小时), 2(1天), 3(7天)
const durationOption = ref(1);

// 读取当前有效的authcode
const {data: currentAuthCode, load: refreshCurrentAuthCode }
 = easy.computedAsyncEx(async () => {
	const {response, error} = await catchError(getCurrentAuthCode());
	if(error) {
		throw new easy.IgnoreError();
	}

	if(response?.code) {
		throw new easy.TipError(response.message);
	}

	return response!.data;
}, {id: 0, 
	authCode: '',
  beginTime: '',
  endTime: ''
})

const scopedTime = computed(
  () =>
    `${dayjs(currentAuthCode.value.beginTime).format('YYYY-MM-DD HH:mm:ss')} 至 ${dayjs(currentAuthCode.value.endTime).format('YYYY-MM-DD HH:mm:ss')}`
)

// 创新授权码
async function onClickCreate() {
	const {response, error} = await catchError(createAuthCode({duration: durationOption.value, product: product}));
	if(error) {
		throw new easy.IgnoreError();
	}

	if(response?.code) {
		throw new easy.TipError(response.message);
	}

	refreshCurrentAuthCode(true);
}

// 终止授权码
async function onClickTerminate() {
	const {response, error} = await catchError(terminateAuthCode({authCodeId: currentAuthCode.value.id}));
	if(error) {
		throw new easy.IgnoreError();
	}

	if(response?.code) {
		throw new easy.TipError(response.message);
	}

	refreshCurrentAuthCode(true);
}

// 剪切板copy
const { copy } =  easy.useClipboard();
function onCopyAuthCode() {
	copy(currentAuthCode.value.authCode);
	ElMessage({
		message:"复制成功",
		type: 'success',
		duration: 500
	})

}

</script>
<style lang="scss" scoped>

.input-panel {
	padding: 16px;
	width: max-content;
	font-size: 14px;

	.input-item {
		display: flex;
		flex-direction: row;
		margin: 16px;

		div:first-child {
			width: 120px;
			margin-right: 16px;
			text-align: right;
		}
	}

	
	.reset-form-button {
		text-align: center;
	}
}

</style>
